
//REMEMBER THIS IS DUPLICATED IN NODE SERVICE, ADD THE COUNCIL TO THERE TOO
export const Authority = {
    NCL: 'NCL',
    NCC: 'NCC',
    NTC: 'NTC',
    STC: 'STC',
    DUR: 'DUR',
    GHD: 'GHD',
    SUN: 'SUN',
    RED: 'RED',
    DEMO: 'DEMO',
}